<template>
  <div class="profile__wrapper">
    <profile-top
      :photo="photo"
      :name="name"
      :position="position"
      :company="company"
    >
      <template v-slot:state>
        <profile-status
          :status="status"
          editable
          @edit="isStatusPopup = true"
        />
      </template>
    </profile-top>
    <popup-card
      v-if="isStatusPopup"
      :is-open="isStatusPopup"
      @show="isStatusPopup = false"
    >
      <ul class="status-list">
        <li>
          <button
            :class="{ 'is-selected': !status }"
            type="button"
            class="status-option"
            @click="chooseStatus(null)"
          >
            <!-- иконки у «без статуса» нет, но отступ нужен: иначе строка
                 съезжает влево и список выглядит рваным -->
            <i class="status-option__blank" />
            <span class="status-option__text">
              {{ $t('shared.participantStatus.none') }}
            </span>
            <i
              v-if="!status"
              class="exu-check"
            />
          </button>
        </li>
        <li
          v-for="item in statuses"
          :key="item.code"
        >
          <button
            :class="{ 'is-selected': status === item.code }"
            type="button"
            class="status-option"
            @click="chooseStatus(item.code)"
          >
            <i :class="item.icon" />
            <span class="status-option__text">{{ $t(item.labelKey) }}</span>
            <i
              v-if="status === item.code"
              class="exu-check"
            />
          </button>
        </li>
      </ul>
    </popup-card>
    <div class="profile-content full-size">
      <div
        v-if="isBarcode"
        class="hot-link-panel"
      >
        <div class="row">
          <div class="col-12">
            <up-card>
              <div>
                <h4 class="m-0 text-center">{{ $t('userProfile.barcode_title') }}</h4>
                <svg
                  id="barcode"
                  class="profile-barcode"
                ></svg>
              </div>
            </up-card>
          </div>
        </div>
      </div>
      <div
        v-if="isHotPanel"
        class="hot-link-panel"
      >
          <div class="row g-2 justify-content-evenly">
              <div v-if="false" class="col-6">
                <up-card>
                  <div class="hot-link">
                    <i class="exu-mail-2" />
                    <span class="hot-link-text">{{ $t('userProfile.messages') }}</span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="{ path: '/chat' }"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
              <div v-if="isCardCreated !== null" class="col-6">
                <up-card>
                  <div class="hot-link">
                    <i class="exu-persone-card" />
                    <span class="hot-link-text">
                      {{ isCardCreated
                        ? $t('userProfile.my_card')
                        : $t('userProfile.create_card') }}
                    </span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="isCardCreated ? '/business-card/preview' : '/business-card/edit'"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
              <div v-if="isBusinessCard" class="col-6">
                <up-card>
                  <div class="hot-link">
                    <i class="exu-users" />
                    <span class="hot-link-text">{{ $t('userProfile.participants_cards') }}</span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="{ path: '/business-card/collection' }"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
              <!-- Во всю ширину: плитка идёт третьей, а при нечётном их числе
                   последняя переносится на свою строку и висела бы половинкой
                   по центру. -->
              <div v-if="canScan" class="col-12">
                <up-card>
                  <div class="hot-link hot-link--wide">
                    <i class="exu-scan" />
                    <span class="hot-link-text">{{ $t('userProfile.scanner') }}</span>
                  </div>
                  <template v-slot:stretch-link>
                    <router-link
                      :to="{ name: 'ScanerPage' }"
                      class="stretch-link"
                    />
                  </template>
                </up-card>
              </div>
          </div>
      </div>
    </div>
    <profile-rubrics :rubrics="userData.rubrics" />
    <div class="profile-content__wrapper">
      <div class="profile-content">
      </div>
    </div>
  </div>
</template>

<script>
import appBaseNav from '@/components/mixins/appBaseNav';
import userMethods from '@/components/mixins/methodsUser';
import ExuBarcode from '@//components/mixins/barcodeMethods';
import businessCard from '@/components/mixins/methodsBusinessCard';
import statusMethods from '@/components/mixins/api/apiMethodsParticipantStatus';
import { PARTICIPANT_STATUSES, findStatus } from '@/components/mixins/participantStatusList';
import { canUseScanner } from '@/components/scanner/config';
import ProfileRubrics from '@/components/shared/ProfileRubrics.vue';
import ProfileStatus from '@/components/shared/ProfileStatus.vue';
// ВРЕМЕННО: отладка push, уходит вместе с рубежом 2
// import PushDebugCard from '@/components/shared/PushDebugCard.vue';

export default {
  name: 'UserProfile',
  // components: { ProfileRubrics, ProfileStatus, PushDebugCard },
  components: { ProfileRubrics, ProfileStatus },
  props: {
    id: {
      requared: true,
    },
    locale: {
      type: String,
    },
  },
  data() {
    return {
      userData: {
        type: Object,
        default: () => ({}),
      },
      isCardCreated: null,
      status: null,
      isStatusPopup: false,
      // выбор сделан руками — ответ профиля его больше не перебивает.
      // App.vue пересоздаёт router-view после загрузки конфига, поэтому запрос
      // профиля уходит дважды, и второй ответ приходит уже после выбора
      statusTouched: false,
    };
  },
  mixins: [appBaseNav, userMethods, ExuBarcode, businessCard, statusMethods],
  computed: {
    statuses() {
      return PARTICIPANT_STATUSES;
    },
    // ВРЕМЕННО: отладочная панель push живёт только на стенде. У клиента домен
    // в store другой, поэтому на боевом её не видно. Уходит вместе с рубежом 4
    isDevStand() {
      return this.$store.getters.apiDomain.includes('dev.expoup.ru');
    },
    name() {
      return this.userData.name || '';
    },
    position() {
      return this.userData.position || '';
    },
    company() {
      return this.userData.company || '';
    },
    photo() {
      return this.userData.photo || '';
    },
    isBarcode() {
      return !!this.userData.user_code;
    },
    barcode() {
      return this.userData.user_code;
    },
    isBusinessCard() {
      return this.$store.getters.isBusinessCard;
    },
    // Кому доступен сканер, решает его собственный конфиг: там же лежит будущая
    // проверка роли, и разъезжаться этим двум местам нельзя.
    canScan() {
      return canUseScanner(this.$store.getters.getUserRole);
    },
    // Условие перечисляет всё, что может оказаться в панели: плитка визиток
    // пропадает вместе с выключенным модулем, плитка сканера — по роли, и
    // панель прячется, только когда не осталось ни одной.
    isHotPanel() {
      return this.isBusinessCard || this.canScan;
    },
  },
  watch: {
    locale() {
      this.$store.commit('setPageTitle', this.$t('userProfile.header_title'));
    },
  },
  beforeCreate() {
    try {
      if (!this.$store.getters.isAuth) {
        this.$router.push({ name: 'loginView' });
      }
    } catch (e) {
      console.error(e);
    }
  },
  mounted() {
    this.$store.commit('setPageTitle', this.$t('userProfile.header_title'));
    if (this.$store.getters.isAuth) {
      this.$emit('loading', true);
      this.loadCached();
      this.getUserProfile()
        .then((result) => {
          this.$emit('loading', false);
          this.userData = { ...result };
          this.applyStatus(result.status);
          return this.barcode;
        // })
        // .then((barcode) => {
        //   if (barcode) {
        //     this.createBarcode('barcode', barcode);
        //   }
        });
      if (this.isBusinessCard) {
        this.getMyBusinessCard()
          .then((data) => {
            this.isCardCreated = data.is_created;
          })
          .catch(() => {
            this.isCardCreated = false;
          });
      }
    }
  },
  updated() {
    if (this.isBarcode) {
      this.createBarcode('barcode', this.barcode);
    }
  },
  methods: {
    loadCached() {
      const jsonCachingProfile = localStorage.getItem('profile');
      if (jsonCachingProfile) {
        this.userData = JSON.parse(jsonCachingProfile);
        this.applyStatus(this.userData.status);
        this.$emit('loading', false);
      }
    },
    /**
     * Ставит статус из ответа или из кеша, но никогда не поверх выбора.
     *
     * Незнакомый код приводим к «без статуса»: сервер может отдать значение,
     * которого эта сборка не знает, и тогда галочка в списке не встала бы ни
     * на одну строку. Заодно защищает от того, что getUserProfile() при
     * неудаче возвращает не профиль, а объект ошибки.
     */
    applyStatus(value) {
      if (this.statusTouched) return;
      this.status = findStatus(value) ? value : null;
    },
    chooseStatus(code) {
      this.isStatusPopup = false;
      if (code === this.status) return;

      const previous = this.status;
      this.statusTouched = true;
      // показываем сразу: ждать ответа значит держать попап открытым
      this.status = code;
      this.setMyStatus(code)
        .then(() => this.cacheStatus(code))
        .catch((error) => {
          this.status = previous;
          console.error(error);
        });
    },
    /**
     * Правит статус в кеше профиля.
     *
     * getUserProfile() кладёт профиль в localStorage целиком, и после записи
     * статуса кеш устаревает. loadCached() читает его до ответа сервера, так
     * что при следующем заходе на экран мелькнуло бы прежнее значение.
     */
    cacheStatus(code) {
      const jsonCachingProfile = localStorage.getItem('profile');
      if (!jsonCachingProfile) return;
      try {
        const profile = JSON.parse(jsonCachingProfile);
        profile.status = code;
        localStorage.setItem('profile', JSON.stringify(profile));
      } catch (e) {
        // кеш нечитаем — не наша забота, профиль всё равно придёт с сервера
        console.error(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/style/variables.scss';

.status-list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding: 0;
  list-style: none;
}
.status-option {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  border: none;
  border-radius: 12px;
  background: transparent;
  color: $color-text;
  font-size: 16px;
  line-height: 1.3em;
  text-align: left;

  &.is-selected {
    background: rgba($color-primary, .09);
  }

  &__text {
    flex: 1 1 auto;
  }

  &__blank {
    width: 16px;
  }

  .exu-check {
    color: $color-primary;
  }
}
.profile {
  &__wrapper {
  display: flex;
  flex-direction: column;
  row-gap: 24px;
  min-height: 100%;
  padding-bottom: 24px;
}
  &-content {
    &__wrapper {
      display: flex;
      width: 100%;
      max-width: 760px;
      margin: 0 auto;
      align-items: center;
      flex: 3 1 100%;
      align-self: stretch;
    }
  }

  &-barcode {
    width: 100%;
  }
}
.profile-content {
  display: flex;
  padding: 0px 12px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;

  &.full-size {
    width: 100%;
    max-width: 760px;
    margin: 0 auto;
  }

  .hot-link-panel {
    width: 100%;
    color: #2D3038;

    i {
      font-size: 36px;
      color: #FCB136;
    }
  }
  .hot-link {
    display: flex;
    height: 100%;
    align-items: center;
    justify-content: space-evenly;
    gap: 10px;
    padding: 0;

    @media(max-width: 450px) {
      & {
        padding: 24px 10px;
      }
    }

    .hot-link-text {

      display: block;
      font-size: 16px;
      line-height: 1.15em;
      color: #2D3038;
      text-decoration: none;
      text-align: left;
    }

    // На половинной плитке space-evenly держит иконку и подпись рядом, а на
    // плитке во всю ширину растаскивает их по краям. Широкой нужна не
    // раздача свободного места, а пара по центру.
    &--wide {
      justify-content: center;
    }
  }

  .description-paragraph {
    color: #95969D;
    // font-family: Roboto;
    // font-size: 14px;
    text-align: justify;
    margin: 0;
  }
}
</style>
